const rules = {
  // 成员姓名
  userName: {
    pattern: /^[a-zA-Z0-9\u4e00-\u9fa5\s+/\\.,;:!?[()\]\\{}_\-\\$€£#@*+&~ ]{2,120}$/,
    // lg: "仅2-120字母,数字,汉字和部分符号"
    message: $t("8vwbxtj", "仅2-120字母,数字,汉字和部分符号")
  },
  // 成员姓/名
  name: {
    pattern: /^[a-zA-Z0-9\u4e00-\u9fa5\s+/\\.,;:!?[()\]\\{}_\-\\$€£#@*+&~ ]{1,60}$/,
    // lg: "仅1-60字母,数字,汉字和部分符号"
    message: $t("b8zejni", "仅1-60字母,数字,汉字和部分符号")
  },
  nickName: {
    pattern: /^[a-zA-Z0-9\u4e00-\u9fa5\s+/\\.,;:!?[()\]\\{}_\-\\$€£#@*+&~ ]{2,25}$/,
    // lg: "仅2-25字母,数字,汉字和部分符号"
    message: $t("y5pzlni", "仅2-25字母,数字,汉字和部分符号")
  },
  userNumber: {
    pattern: /^[a-zA-Z0-9\-\\_]{0,25}$/,
    // lg: 仅字母、数字、符号_或-,长度25以内
    message: $t("e9vx39j", "仅字母、数字、符号_或-,长度25以内")
  },
  userCode: {
    pattern: /^[A-Z0-9_-]{1,20}$/,
    // lg: 仅1-20大写字母、数字、符号_或-
    message: $t("24ct0bi", "仅1-20大写字母、数字、符号_或-")
  },
  // 部门代码/岗位代码
  positionCode: {
    pattern: /^[A-Z0-9_-]{0,20}$/,
    // lg: 支持大写字母、数字、符号_ 或 - 组成，长度40个以内
    message: $t("36nwu1s", "支持大写字母、数字、符号_ 或 - 组成，长度20个以内")
  },
  // 部门名称/岗位名称
  positionName: {
    pattern: /^[a-zA-Z0-9\u4e00-\u9fa5]{2,25}$/,
    // lg: 仅支持字母数字汉字2-25个字符的命名
    message: $t("pmcb1hj", "仅支持字母数字汉字2-25个字符的命名")
  },
  tagDescription: {
    pattern: /^.{0,50}$/,
    // lg: 仅支持50个字符以内的命名
    message: $t("xcd8zxd", "仅支持50个字符以内的命名")
  },
  // 成员邮箱
  userEmail: {
    pattern: /.*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
    // lg: 邮箱格式不正确
    message: $t("venleq7", "邮箱格式不正确")
  }
};
export default rules;